import Helpers from "../../helpers/helpers";
import { server } from "../globalSettings";

export const requestAuthOption = (method, data) => {
    let isRemember = localStorage.getItem("remember");
    let token = JSON.parse(localStorage.getItem("token"))

    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
        };
        return requestOptions
    }

}

export const customerListingApi = async (payload) => {
    const request = requestAuthOption("GET")
    let doctorIds = "";
    let stateIds = "";
    if (payload?.doctor_ids?.length > 0) {
        doctorIds = payload.doctor_ids.map(id => `doctor_ids[]=${encodeURIComponent(id)}`).join('&');
    }
    if (payload?.state_id?.length > 0) {
        stateIds = payload.state_id.map(id => `state_ids[]=${encodeURIComponent(id)}`).join('&');
    }
    try {
        const response = await fetch(
            `${server}customers?paginate=${payload?.page}&size=${payload?.length}&search=${payload?.search}${stateIds ? `&${stateIds}` : ""}${doctorIds ? `&${doctorIds}` : ""}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const createCustomerApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(
            `${server}customer`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const editCustomerApi = async (payload) => {
    const request = requestAuthOption("PUT", payload.data)
    try {
        const response = await fetch(
            `${server}customer/${payload?.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const deleteCustomerApi = async (payload) => {
    const request = requestAuthOption("DELETE")
    try {
        const response = await fetch(
            `${server}customer/${payload?.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const customerActivationApi = async (payload) => {
    const request = requestAuthOption("POST")
    try {
        const response = await fetch(
            `${server}customer/${payload?.id}/${payload?.action}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const getCustomerDetailsApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}customer/${payload?.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data?.data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const getCustomerHistoryApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}customer/${payload?.id}/histories`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const switchCustomerApi = async (payload) => {
    const request = requestAuthOption("PUT", payload.data)
    try {
        const response = await fetch(
            `${server}customer/${payload?.id}/doctor`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const getCustomerOrdersApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}customer/${payload?.id}/orders?paginate=${payload?.page}&size=${payload?.length}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const exportCustomerListingApi = async (payload) => {
    const request = requestAuthOption("POST");

    let doctorIds = "";
    let stateIds = "";
    if (payload?.doctor_ids?.length > 0) {
        doctorIds = payload.doctor_ids.map(id => `doctor_ids[]=${encodeURIComponent(id)}`).join('&');
    }
    if (payload?.state_id?.length > 0) {
        stateIds = payload.state_id.map(id => `state_ids[]=${encodeURIComponent(id)}`).join('&');
    }
    try {
        const response = await fetch(
            `${server}customers/export?search=${payload?.search}${stateIds ? `&${stateIds}` : ""}${doctorIds ? `&${doctorIds}` : ""}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};
